webpackJsonp([0],{

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(159);

var _components = __webpack_require__(754);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GettingStarted = function (_Component) {
  _inherits(GettingStarted, _Component);

  function GettingStarted() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GettingStarted);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GettingStarted.__proto__ || Object.getPrototypeOf(GettingStarted)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      // print the form values to the console

      // console.log(values)

      var formUri = "https://afrodesiamedia.com/admin/api/forms/submit/gettingstarted?token=7289370ee7736e97be508a8fba6003";

      var apiUri = "https://afrodesiamedia.com/admin/api/collections/save/getting?token=7289370ee7736e97be508a8fba6003";

      fetch(apiUri, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          data: values
        })
      }).then(function (collection) {
        return collection.json();
      });
      // .then(collection => console.log(collection));
      // this.props.history.push('/inquiry-submition')
      // localStorage.setItem('values', values);

      fetch(formUri, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form: values
        })
      }).then(function (entry) {
        return entry.json();
      });
      // .then(entry => console.log(entry));
      _this.props.history.push('/inquiry-submition');
      localStorage.setItem({ form: values });
      // console.log(values)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GettingStarted, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            "title",
            null,
            " Getting Started - afrodesiamedia "
          ),
          _react2.default.createElement("link", { rel: "shortcut icon", href: "/favicon.ico" }),
          _react2.default.createElement("meta", { property: "og:title", content: "Getting Started" })
        ),
        _react2.default.createElement(
          "section",
          { className: "GettingStarted" },
          _react2.default.createElement(
            "header",
            { className: "heading" },
            _react2.default.createElement(
              "h1",
              null,
              "Getting Started"
            )
          ),
          _react2.default.createElement(_components.InquiryForm, { onSubmit: this.submit })
        )
      );
    }
  }]);

  return GettingStarted;
}(_react.Component);

exports.default = GettingStarted;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderInput = exports.renderTextArea = exports.validate = undefined;

var _validate = __webpack_require__(777);

var _validate2 = _interopRequireDefault(_validate);

var _renderInput = __webpack_require__(778);

var _renderInput2 = _interopRequireDefault(_renderInput);

var _renderTextArea = __webpack_require__(779);

var _renderTextArea2 = _interopRequireDefault(_renderTextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.validate = _validate2.default;
exports.renderTextArea = _renderTextArea2.default;
exports.renderInput = _renderInput2.default;

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var label = exports.label = void 0;

var required = exports.required = function required(value) {
  return value || typeof value === 'number' ? undefined : 'This info is required!';
};
var emailRequired = exports.emailRequired = function emailRequired(value) {
  return value || typeof value === 'number' ? undefined : 'Please provide and valid email!';
};
var phoneRequired = exports.phoneRequired = function phoneRequired(value) {
  return value || typeof value === 'number' ? undefined : 'Please provide and valid phone number!';
};
var maxLength = exports.maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? 'Must be ' + max + ' characters or less' : undefined;
  };
};
var maxLength15 = exports.maxLength15 = maxLength(15);
var minLength = exports.minLength = function minLength(min) {
  return function (value) {
    return value && value.length < min ? 'Must be ' + min + ' characters or more' : undefined;
  };
};
var minLength2 = exports.minLength2 = minLength(2);
var number = exports.number = function number(value) {
  return value && isNaN(Number(value)) ? 'Must be a number' : undefined;
};
var minValue = exports.minValue = function minValue(min) {
  return function (value) {
    return value && value < min ? 'Must be at least ' + min : undefined;
  };
};
var minValue13 = exports.minValue13 = minValue(13);
var email = exports.email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined;
};
var tooYoung = exports.tooYoung = function tooYoung(value) {
  return value && value < 13 ? 'You do not meet the minimum age requirement!' : undefined;
};
var aol = exports.aol = function aol(value) {
  return value && /.+@aol\.com/.test(value) ? 'Really? You still use AOL for your email?' : undefined;
};
var alphaNumeric = exports.alphaNumeric = function alphaNumeric(value) {
  return value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters' : undefined;
};
var phoneNumber = exports.phoneNumber = function phoneNumber(value) {
  return (
    // value && !/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/i.test(value)
    value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? 'Invalid phone number, must be 10 digits' : undefined
  );
};

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderFields = exports.StepThree = exports.StepTwo = exports.StepOne = exports.InquiryForm = undefined;

var _InquiryForm = __webpack_require__(775);

var _InquiryForm2 = _interopRequireDefault(_InquiryForm);

var _StepOne = __webpack_require__(776);

var _StepOne2 = _interopRequireDefault(_StepOne);

var _StepTwo = __webpack_require__(780);

var _StepTwo2 = _interopRequireDefault(_StepTwo);

var _StepThree = __webpack_require__(781);

var _StepThree2 = _interopRequireDefault(_StepThree);

var _RenderFields = __webpack_require__(782);

var _RenderFields2 = _interopRequireDefault(_RenderFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.InquiryForm = _InquiryForm2.default;
exports.StepOne = _StepOne2.default;
exports.StepTwo = _StepTwo2.default;
exports.StepThree = _StepThree2.default;
exports.RenderFields = _RenderFields2.default;

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ = __webpack_require__(754);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import ScrollAnimation from 'react-animate-on-scroll'
// import PropTypes from 'prop-types'

var InquiryForm = function (_Component) {
  _inherits(InquiryForm, _Component);

  function InquiryForm(props) {
    _classCallCheck(this, InquiryForm);

    var _this = _possibleConstructorReturn(this, (InquiryForm.__proto__ || Object.getPrototypeOf(InquiryForm)).call(this, props));

    _this.nextPage = _this.nextPage.bind(_this);
    _this.previousPage = _this.previousPage.bind(_this);
    _this.state = {
      page: 1
    };
    return _this;
  }

  _createClass(InquiryForm, [{
    key: 'nextPage',
    value: function nextPage() {
      this.setState({ page: this.state.page + 1 });
    }
  }, {
    key: 'previousPage',
    value: function previousPage() {
      this.setState({ page: this.state.page - 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var onSubmit = this.props.onSubmit;
      var page = this.state.page;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        page === 1 && _react2.default.createElement(_.StepOne, {
          onSubmit: this.nextPage
        }),
        page === 2 && _react2.default.createElement(_.StepTwo, {
          previousPage: this.previousPage,
          onSubmit: this.nextPage
        }),
        page === 3 && _react2.default.createElement(_.StepThree, {
          previousPage: this.previousPage,
          onSubmit: onSubmit
        })
      );
    }
  }]);

  return InquiryForm;
}(_react.Component);

// InquiryForm.propTypes = {
//   onSubmit: PropTypes.func.isRequired
// }

exports.default = InquiryForm;

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__(262);

var _helpers = __webpack_require__(749);

var _Validate = __webpack_require__(750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inquire Import

// import { validate, renderInput, renderTextArea  } from  './'
var StepOne = function StepOne(props) {
  var handleSubmit = props.handleSubmit,
      pristine = props.pristine,
      submitting = props.submitting;


  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'section',
      { className: 'stepOne' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'aside',
          { className: 'sidebar' },
          _react2.default.createElement(
            'h3',
            null,
            'Personal Info'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please tell us about your self to start the process'
          )
        ),
        _react2.default.createElement(
          'article',
          { className: 'wizardform' },
          _react2.default.createElement(
            'form',
            { onSubmit: handleSubmit },
            _react2.default.createElement(
              'fieldset',
              null,
              _react2.default.createElement(_reduxForm.Field, {
                name: 'firstName',
                type: 'text',
                component: _helpers.renderInput,
                label: 'First Name',
                validate: _Validate.required
              }),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'lastName',
                type: 'text',
                component: _helpers.renderInput,
                label: 'Last Name',
                validate: _Validate.required
              }),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'phone',
                type: 'text',
                component: _helpers.renderInput,
                label: 'Phone',
                validate: [_Validate.phoneNumber, _Validate.phoneRequired],
                placeholder: '18000001234'
              }),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'email',
                type: 'text',
                component: _helpers.renderInput,
                label: 'email',
                validate: [_Validate.email, _Validate.emailRequired]
              }),
              _react2.default.createElement(
                'button',
                { className: 'btn', type: 'submit', disabled: pristine || submitting },
                'Next'
              )
            )
          )
        )
      )
    )
  );
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: _helpers.validate
})(StepOne);

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validate = function validate(values) {
  var errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lasttName = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  }
  if (!values.companyInfo) {
    errors.companyInfo = 'Required';
  }
  if (!values.companyLocation) {
    errors.companyLocation = 'Required';
  }
  if (!values.companyPostion) {
    errors.companyPostion = 'Required';
  }
  if (!values.aboutProject) {
    errors.aboutProject = 'Required';
  }
  if (!values.projectGoals) {
    errors.projectGoals = 'Required';
  }
};
exports.default = validate;

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderInput = function renderInput(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      placeholder = _ref.placeholder,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "div",
      { className: "form-group" },
      _react2.default.createElement("input", _extends({}, input, {
        type: type,
        placeholder: placeholder
      })),
      _react2.default.createElement(
        "label",
        null,
        label
      ),
      _react2.default.createElement(
        "div",
        { className: "error" },
        touched && (error && _react2.default.createElement(
          "span",
          null,
          error
        ) || warning && _react2.default.createElement(
          "span",
          null,
          warning
        ))
      )
    )
  );
};

exports.default = renderInput;

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTextArea = function renderTextArea(_ref) {
  var textarea = _ref.textarea,
      label = _ref.label,
      type = _ref.type,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "div",
      { className: "form-group" },
      _react2.default.createElement(
        "label",
        null,
        label
      ),
      _react2.default.createElement("textarea", _extends({}, textarea, {
        type: type
      })),
      touched && error && _react2.default.createElement(
        "span",
        null,
        " ",
        error
      )
    )
  );
};

exports.default = renderTextArea;

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__(262);

var _helpers = __webpack_require__(749);

var _Validate = __webpack_require__(750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Inquire Import
// import { validate, renderInput, renderTextArea  } from  './'
var StepTwo = function StepTwo(props) {
  var handleSubmit = props.handleSubmit,
      previousPage = props.previousPage,
      pristine = props.pristine,
      submitting = props.submitting;


  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'section',
      { className: 'stepOne' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'aside',
          { className: 'sidebar' },
          _react2.default.createElement(
            'h3',
            null,
            'Company Details'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please provide us info about your company'
          )
        ),
        _react2.default.createElement(
          'article',
          { className: 'wizardform' },
          _react2.default.createElement(
            'form',
            { onSubmit: handleSubmit },
            _react2.default.createElement(
              'fieldset',
              null,
              _react2.default.createElement(_reduxForm.Field, {
                name: 'companyName',
                type: 'text',
                component: _helpers.renderInput,
                label: 'Company Name',
                validate: _Validate.required
              }),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'companyPosition',
                type: 'text',
                component: _helpers.renderInput,
                label: 'Company Position',
                validate: _Validate.required
              }),
              _react2.default.createElement(_reduxForm.Field, {
                name: 'companyLocation',
                type: 'text',
                component: _helpers.renderInput,
                label: 'Company Location'
              }),
              _react2.default.createElement(
                'button',
                { className: 'btn previous', type: 'button', onClick: previousPage },
                'Previous'
              ),
              _react2.default.createElement(
                'button',
                { className: 'btn next', type: 'submit', disabled: pristine || submitting },
                'Next'
              )
            )
          )
        )
      )
    )
  );
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: _helpers.validate
})(StepTwo);

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reduxForm = __webpack_require__(262);

var _helpers = __webpack_require__(749);

var _Validate = __webpack_require__(750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { connect } from 'react-redux'

// Inquire Import
// import { validate, renderInput, renderTextArea  } from  './'
var StepThree = function StepThree(props) {
  var handleSubmit = props.handleSubmit,
      previousPage = props.previousPage,
      pristine = props.pristine,
      submitting = props.submitting;


  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'section',
      { className: 'stepTwo' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'aside',
          { className: 'sidebar' },
          _react2.default.createElement(
            'h3',
            null,
            'Project Details :'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please provide us with any details concering the nature of your project.'
          )
        ),
        _react2.default.createElement(
          'article',
          { className: 'wizardform' },
          _react2.default.createElement(
            'form',
            { onSubmit: handleSubmit },
            _react2.default.createElement(
              'fieldset',
              null,
              _react2.default.createElement(
                'div',
                { className: 'form-group text-area' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'aboutProject' },
                  'about the project'
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'aboutProject',
                  type: 'text',
                  component: 'textarea',
                  label: 'About Project',
                  validate: _Validate.required
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'form-group ' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'projectGoal' },
                  'what are the project goals?'
                ),
                _react2.default.createElement(_reduxForm.Field, {
                  name: 'projectGoal',
                  type: 'text',
                  component: 'textarea',
                  label: 'Company Name',
                  validate: _Validate.required
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'button-group' },
                _react2.default.createElement(
                  'button',
                  { className: 'btn previous', type: 'button', onClick: previousPage },
                  'Previous'
                ),
                _react2.default.createElement(
                  'button',
                  { className: 'btn next', disabled: pristine || submitting, type: 'submit' },
                  'Submit'
                )
              )
            )
          )
        )
      )
    )
  );
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: _helpers.validate
})(StepThree);

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(751);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderFields = function RenderFields(_ref) {
  var input = _ref.input,
      label = _ref.label,
      type = _ref.type,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning;
  return _react2.default.createElement(
    'div',
    { className: 'form-group' },
    _react2.default.createElement('input', _extends({}, input, { type: type, className: (0, _classnames2.default)('form-control') })),
    _react2.default.createElement(
      'label',
      null,
      label
    ),
    _react2.default.createElement(
      'div',
      { className: 'error' },
      touched && (error && _react2.default.createElement(
        'span',
        null,
        error
      ) || warning && _react2.default.createElement(
        'span',
        null,
        warning
      ))
    )
  );
};
exports.default = RenderFields;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/GettingStarted/GettingStarted.0881bf75.js